import React, { useState, useEffect } from 'react';
import { AgGrid } from '../AgGrid';
import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { getFileImportHistory } from '../../services';

export const FILE_IMPORT_HISTORY_GRID_NAMES = {
  DASHBOARD: 'DASHBOARD',
  IMPORT_PAGE: 'IMPORT_PAGE',
};

const styles = props => ({});

export const FileImportHistoryGrid = withStyles(styles)(({ gridName }) => {
  const [importHistory, setImportHistory] = useState(null);
  const [importLineColDefs, setImportLineColDefs] = useState([
    { headerName: 'Agent', field: 'agentname' },
    { headerName: 'Customer Code', field: 'customercode' },
    { headerName: 'Building Coverage', field: 'buildingcoverage' },
    { headerName: 'Address', field: 'fullAddr' },
    { headerName: 'Name', field: 'insuredname' },
    { headerName: 'Policy', field: 'policy' },
    { headerName: 'Report Code', field: 'reportcode' },
    { headerName: 'Construction Year', field: 'yearofconstruction' },
    { headerName: 'Underwriter Code', field: 'underwritercode' },
    { headerName: 'Import Status', field: 'importStatus' },
  ]);

  const historyColDefs = [
    {
      headerName: 'Filename',
      field: 'fileName',
      cellRenderer: 'agGroupCellRenderer',
      width: 400,
    },
    {
      headerName: 'Import Total',
      cellRenderer: ({ data }) => (data && data.importLine ? data.importLine.length : ''),
      valueGetter: ({ data }) => (data && data.importLine ? data.importLine.length : ''),
    },
    // { headerName: 'Import Total', field: 'importTotal' },
    { headerName: 'Created On', field: 'createdOn', cellRenderer: 'dateUTC' },
    { headerName: 'Data Source', field: 'dataSource' },
    { headerName: 'Imported By', field: 'importedBy' },
    { headerName: 'Is Finished Importing', field: 'isProcessed' },
    { headerName: 'Import Failure Count', field: 'numberOfFailures' }
    // { headerName: "History Type", field: "histType", rowGroup: true, hide: true, },
  ];

  const detailCellRendererParams = {
    detailGridOptions: {
      columnDefs: importLineColDefs,
      defaultColDef: {
        editable: false,
        resizable: true,
      },
    },
    getDetailRowData: async function(params) {
      params.successCallback(params.data.importLine);
    },
  };

  const gridOptions = {
    detailCellRendererParams,
    masterDetail: true,
  };

  const getFileImportHistoryAsync = async () => {
    try {
      const res = await getFileImportHistory();
      let tempImportLineColDefs = {};

      if (res.length && res[0].importLine && res[0].importLine[0]) {
        tempImportLineColDefs = Object.keys(res[0].importLine[0]).reduce((acc, cur) => {
          if (!acc[cur]) {
            acc[cur] = cur;
          }
          return acc;
        }, {});
        tempImportLineColDefs = Object.keys(tempImportLineColDefs).map(col => {
          return {
            field: col,
          };
        });
        setImportLineColDefs(tempImportLineColDefs);
      }
      setImportHistory(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFileImportHistoryAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center', 'align-stretch')} style={{ minHeight: 500 }}>
      <AgGrid
        columnDefs={historyColDefs}
        redirectOnClick={false}
        editOnClick={false}
        gridOptions={gridOptions}
        //
        // lazy loaded params
        datasourceUrl={'/FileImport/history'}
        useDatasource={true}
        allowServerExport={false}
        gridName={gridName}
      />
    </div>
  );
});

FileImportHistoryGrid.propTypes = {
  gridName: PropTypes.string,
};
FileImportHistoryGrid.defaultProps = {
  gridName: FILE_IMPORT_HISTORY_GRID_NAMES.DASHBOARD,
};
